import axios from 'axios';
import { useState } from 'react';

// TODO: make content type more restrictive. ex. 'video/mp4' | 'image/jpg'
const useUploadToS3 = () => {
  const [status, setStatus] = useState<string>('idle');
  const [url, setUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [progress, setProgress] = useState<number>(0);

  const upload = (blob: Blob, contentType: string) => {
    setStatus('pending');

    // TODO: make this async/await?
    axios
      .post('/api/presignedUploadUrl', { contentType })
      .then(response => {
        const { signedRequest, url } = response.data;
        const options = {
          headers: {
            'Content-Type': contentType,
            'Access-Control-Allow-Origin': '*',
          },
          onUploadProgress: (progressEvent: any) =>
            setProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total)),
        };

        axios
          .put(signedRequest, blob, options)
          .then(res => {
            setUrl(url);
            setStatus('success');
          })
          .catch(error => {
            setError(error);
            setStatus('error');
          });
      })
      .catch(error => {
        setError(error);
        setStatus('error');
      });
  };

  return { upload, url, status, error, progress };
};

export default useUploadToS3;
